import { BasicResult } from '../basic-result';
import { EventTemplate } from './event-template';
import { EventTemplateLocation } from './event-template-location';

export class EventTemplateListResult extends BasicResult {
  Templates: EventTemplate[] = [];
  Locations: EventTemplateLocation[] = [];
}
